import React from 'react'

// Headers configuration component for HTTP requests

const HeadersConfig = ({ headers = [], onChange }) => {
    const addHeader = () => {
        onChange([...headers, { key: '', value: '' }]);
    };

    const updateHeader = (index, field, val) => {
        const newHeaders = [...headers];
        newHeaders[index][field] = val;
        onChange(newHeaders);
    };

    const removeHeader = (index) => {
        onChange(headers.filter((_, i) => i !== index));
    };

    return (
        <div className="space-y-2">
            <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Headers HTTP</label>
            <div className="space-y-2 max-h-48 overflow-y-auto pr-2">
                {headers.map((header, idx) => (
                    <div key={idx} className="flex gap-2">
                        <input
                            placeholder="Key"
                            value={header.key || ''}
                            onChange={(e) => updateHeader(idx, 'key', e.target.value)}
                            className="flex-1 min-w-0 px-2 py-1.5 text-xs border border-gray-300 dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white focus:outline-none focus:border-blue-500"
                        />
                        <input
                            placeholder="Value"
                            value={header.value || ''}
                            onChange={(e) => updateHeader(idx, 'value', e.target.value)}
                            className="flex-1 min-w-0 px-2 py-1.5 text-xs border border-gray-300 dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white focus:outline-none focus:border-blue-500"
                        />
                        <button
                            onClick={() => removeHeader(idx)}
                            className="text-red-500 hover:text-red-700 transition flex-shrink-0"
                            title="Remover header"
                        >
                            <span className="material-icons sm">close</span>
                        </button>
                    </div>
                ))}
            </div>
            <button
                onClick={addHeader}
                className="text-blue-500 hover:text-blue-700 text-sm flex items-center gap-1 transition"
            >
                <span className="material-icons sm">add</span> Adicionar Header
            </button>
        </div>
    );
};

export default HeadersConfig
